import { AnyType } from '@thehubz/shared/model';

const assets: AnyType[] = [];

export const AssetsNFilesConfig = [
  {
    section: 'Original data',
    clusters: [
      {
        type: 'Draft',
      },
      {
        type: 'Briefing document',
      },
      {
        type: 'Briefing',
      },
      {
        type: 'Add briefing details',
      },
      {
        type: 'Submit source file',
      },
    ],
    assetList: assets,
    count: 0,
  },
  {
    section: 'Final data',
    clusters: [
      {
        type: 'Production files',
      },
      {
        type: 'Approved',
      },
      {
        type: 'Internal Approval',
      },
      {
        type: 'Approved by client',
      },
      {
        type: 'Ready for QA',
      },
      {
        type: 'Final data',
      },
      {
        type: 'Convert final data',
      },
      {
        type: 'Submit final data',
      },
    ],
    assetList: assets,
    count: 0,
  },
  {
    section: 'Approval file',
    clusters: [
      {
        type: 'Please upload asset for approval.',
      },
      {
        type: 'Please upload task for approval.',
      },
      {
        type: 'Please submit final CGI.',
      },
      {
        type: 'Please submit task for approval.',
      },
      {
        type: 'Please add further information if required.',
      },
      {
        type: 'Upload asset for approval',
      },
      {
        type: 'Submit for approval',
      },
      {
        type: 'Send for internal approval',
      },
      {
        type: 'Submit for internal approval',
      },
      {
        type: 'Send for client approval',
      },
      {
        type: 'Send for agency approval',
      },
      {
        type: 'Please add further infomation if required.',
      },
    ],
    assetList: assets,
    count: 0,
  },
  {
    section: 'Other files',
    clusters: [
      {
        type: 'Ask question',
      },
      {
        type: 'Briefing incomplete',
      },
      {
        type: 'Please define the rejection reason',
      },
      {
        type: 'Submit new feedback',
      },
      {
        type: 'Info required',
      },
      {
        type: 'Add additional info',
      },
      {
        type: 'Change request',
      },
      {
        type: 'Submit new version',
      },
      {
        type: 'Submit feedback',
      },
      {
        type: 'Client feedback incomplete',
      },
      {
        type: 'Rejection feedback incomplete',
      },
      {
        type: 'Agency feedback incomplete',
      },
      {
        type: 'QA failed',
      },
      {
        type: 'Internally rejected',
      },
      {
        type: 'Feedback incomplete',
      },
      {
        type: 'Add question',
      },
      {
        type: 'Add feedback',
      },
      {
        type: 'Reject task',
      },
      {
        type: 'Request source file',
      },
      {
        type: 'Re-open Task',
      },
      {
        type: 'Please upload asset for edit step',
      },
      {
        type: 'Rejection',
      },
      {
        type: 'Submit agency rejection',
      },
      {
        type: 'Forward feedback',
      },
      {
        type: 'Request upload to adserver',
      },
      {
        type: 'Provide adserver link',
      },
      {
        type: 'Client briefing incomplete',
      },
      {
        type: 'Forward to Studio',
      },
      {
        type: 'Briefing incomplete studio',
      },
    ],
    assetList: assets,
    count: 0,
  },
];
